type navbarStylesClasses =
  | 'container'
  | 'titleLogo'
  | 'tab'
  | 'hoveredText'
  | 'selectedTab'
  | 'navLink'
  | 'drawer'
  | 'selectedListItem'
  | 'tabIndicator';

const navbarStyles: Record<
  navbarStylesClasses,
  | Record<string, string | number>
  | Record<string, Record<string, string | number>>
> = {
  container: {
    padding: '5px',
  },
  titleLogo: {
    fontStyle: 'italic',
    fontWeight: '600',
  },
  tab: {
    padding: 0,
    textTransform: 'capitalize',
  },
  hoveredText: {
    '&:hover': {
      textDecoration: 'underline',
      textDecorationThickness: '4px',
      textUnderlineOffset: '2px',
    },
  },
  selectedTab: {
    '& a': {
      color: 'text.primary',
      textDecoration: 'underline',
      textDecorationThickness: '4px',
      textUnderlineOffset: '2px',
    },
  },
  tabIndicator: {
    display: 'none',
  },
  selectedListItem: {
    color: '#424242',
    textDecoration: 'underline',
    textDecorationThickness: '4px',
    textUnderlineOffset: '2px',
  },
  navLink: {
    color: 'unset',
    textDecoration: 'unset',
  },
  drawer: {
    '& .MuiDrawer-paper': {
      maxWidth: '200px',
      width: '100%',
    },
  },
};

export default navbarStyles;
